import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, Signal } from '@angular/core';
import { select, Store } from '@ngxs/store';
import { CodState } from '../../../state/cod.state';
import { AttachCodLine, OpenForm, ResetErrorMessages, SubmittCod } from '../../../state/cod.action';
import { Router, RouterModule } from '@angular/router';
import { ButtonModule } from '@sag-ui';
import { CodDetailCardComponent } from '../../cod-detail-card/cod-detail-card.component';
import { GeneralCod } from '../../../models/cod.model';
import { Region } from '@cod-monorepo/interfaces';
import { tap } from 'rxjs';

@Component({
    selector: 'app-cod-summary-step',
    templateUrl: './summary.component.html',
    imports: [CommonModule, RouterModule, ButtonModule, CodDetailCardComponent],
    standalone: true
})
export class CodSummaryStepComponent {
    @Input() copyId: string;
    @Output() submitted: EventEmitter<void> = new EventEmitter<void>();
    public codLines: Signal<GeneralCod[]> = select(CodState.mappedCodLines);
    public regions = Region;
    public readonly today = new Date().toLocaleDateString();

    constructor(private store: Store, private router: Router) {}

    public handleSubmit(): void {
        this.store.dispatch(new SubmittCod(this.copyId)).pipe(
            tap(() => {
                this.submitted.emit();
                this.router.navigate(['/']);
            })
        );
    }

    public printSummary(): void {
        void this.generatePdf();
    }

    public addCodLine(): void {
        this.store.dispatch(new ResetErrorMessages());
        this.store.dispatch(new AttachCodLine());
    }

    public openForm(index: number): void {
        this.store.dispatch(new OpenForm(index));
    }

    private async generatePdf(): Promise<void> {
        const element = document.getElementById('cod-summary-print-section');
        if (!element) return;

        element.style.width = '794px';
        element.style.display = 'block';

        try {
            const canvas = await html2canvas(element, {
                scale: 2,
                useCORS: true,
                logging: false,
                backgroundColor: '#ffffff'
            });

            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            const imgHeight = (canvas.height * pageWidth) / canvas.width;

            let heightLeft = imgHeight;
            let position = 0;

            pdf.addImage(imgData, 'PNG', 0, position, pageWidth, imgHeight);
            heightLeft -= pageHeight;

            while (heightLeft > 0) {
                position -= pageHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', 0, position, pageWidth, imgHeight);
                heightLeft -= pageHeight;
            }

            pdf.save(`COD-submission-${this.today.replace(/\//g, '-')}.pdf`);
        } finally {
            element.style.display = 'none';
            element.style.width = '';
        }
    }
}
